import { AccessDeniedReasonsEnum } from './access-denied'

export class CommunityOwnerBlockedError extends Error {
  readonly reason = AccessDeniedReasonsEnum.CommunityOwnerBlocked

  constructor() {
    super('community_owner_blocked')
    this.name = this.constructor.name
  }
}
